export default "__VITE_ASSET__CiqCcheK__"